export default __webpack_public_path__ + "static/media/roadhome2.3936e0c4.png";